import React from "react";
import InvoiceTable from "./components/InvoiceTable";

export function Invoices() {
  return (
    <>
      <InvoiceTable />
    </>
  );
}
